module.exports = __webpack_public_path__ + "img/element-2.5dae3430.svg";